import { createContext } from 'react';

const PrerenderContext = createContext(null);

export default PrerenderContext;
